import React from "react"

const VideoSection = ({ src }) => {
  return (
    <>
      <div className="bg-video w-full max-w-full relative mb-[4rem]">
        <iframe
          src={src}
          className="w-full h-full aspect-video"
          width="560"
          height="315"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
          allowfullscreen
        ></iframe>
      </div>
    </>
  )
}

export default VideoSection
